import { useEffect } from "react";
import { useSelector } from "react-redux";

const NotFoundPage = () => {
  const currentUser = useSelector((state) => state.auth?.currentUser);
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token || !!currentUser;

  useEffect(() => {
    // Add dark-theme class if user is not authenticated
    if (!isAuthenticated) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }

    // Cleanup: remove dark-theme class when component unmounts
    return () => {
      document.body.classList.remove("dark-theme");
    };
  }, [isAuthenticated]);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center error-page"
      style={{ marginTop: "130px" }}
    >
      <img
        className="main-logo"
        alt=""
        src="/images/Error404.svg"
        style={{ maxWidth: "332px" }}
      />

      <div className="mb-4 d-flex flex-column align-items-center justify-content-center px-4 text-center">
        <h1 className="mb-0 mt-1 font_24 font-extrabold ">الصفحة غير موجودة</h1>
        <p className="mb-0 mt-2 font_16 font-color-grey ">
          عفواً يبدو انه تعذر الوصول إلى هذه الصفحة وأنها غير موجودة الآن
        </p>
      </div>

      <a href="/" className="btn btn-main-color font-15">
        العودة للصفحة الرئيسية
        {/* <span className="fas fa-plus fa-fw ms-2"></span> */}
      </a>
    </div>
  );
};

export default NotFoundPage;
